import React, { useEffect, useState } from "react";
import Backicon from "../../assets/icon/leftIcon.png";
import { getCategory } from "../../state/categoryState";
import { getRestaurant } from "../../state/restaurantState";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import useGetImages from "../../components/useGetImages";
import empty from '../../assets/images/empty.jpg';
const CategoryCard = ({ id, category }) => {
  // const [resim, setResim] = useState("");
  // const url ="https://1zw31qczi7.execute-api.eu-central-1.amazonaws.com/prod/category_pictures/" +id +"/" +category.CATEGORY;

  // useEffect(() => {
  //   fetch(url).then((data) => {
  //     data.text().then((text) => setResim(text));
  //   });
  // }, [url]);

  const { image: uri } = useGetImages(
    "category_pictures",
    id,
    category?.CATEGORY
  );
  console.log("uri", uri);

  if (!category) return null;

  return (
    <Link
      to={`/menu?category=${category.CATEGORY}`}
      className="hover:scale-95 transition ease-in-out duration-300 z-10"
    >
      <div className="p-4 bg-zinc-100 m-2 rounded-md h-50 flex flex-col justify-center items-center">
        {/* {uri && (
          <img
            src={uri}
            // src={resim}
            alt="img"
            className="w-24 h-24 object-center rounded-full shadow-md"
          />
        )} */}
             {uri ? (
          <img
            src={uri}
            // src={resim}
            alt="img"
            className="w-24 h-24 object-center rounded-full shadow-md"
          />
        ):(
          <img
          src={empty}
          // src={resim}
          alt="img"
          className="w-24 h-24 object-center rounded-full shadow-md"
        />

        )}

        <p className="text-center text-stone-500 text-sm mt-3">
          {category.CATEGORY}
        </p>
      </div>
    </Link>
  );
};

const Category = ({ id }) => {
  const dispatch = useDispatch();
  const categories = useSelector((state) => state.categories.category);
  const restaurants = useSelector((state) => state.restaurants.restaurant);

  useEffect(() => {
    const data = { path: id + "/categoryno.json" };
    const data3 = { path: id + "/restaurant.json" };

    dispatch(getCategory(data));
    dispatch(getRestaurant(data3));
  }, [dispatch, id]);

  return (
    <div className="min-h-screen flex flex-col">
      <div className="p-4">
        <Link to="/" className="flex items-center mb-4">
          <img src={Backicon} alt="back" className="rounded-full w-8 h-8" />
        </Link>
        <h3 className="font-bold text-xl">Kategoriler</h3>
      </div>
      {categories ? (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-4">
          {categories?.map((item, index) => (
            <CategoryCard id={id} category={item} key={index} />
          ))}
        </div>
      ) : (
        <div className="flex justify-center items-center mt-10">
          <p>Yükleniyor...</p>
        </div>
      )}
    </div>
  );
};

export default Category;
